import _ from 'lodash'

/*
** Handle stock level = null means it's unlimited
*/
export default function parseStockLevel(n) {
  return _.isNull(n) || _.isUndefined(n) ? Infinity : n
}
